import { useChatContext } from '@/chat/ChatContext';
import { getLabel } from '@/i18n/maps';
import type { RelatedPagesSection } from '@/types/chat';

export function RelatedPagesView({ section }: { section: RelatedPagesSection }): JSX.Element | null {
  const { payload, locale } = useChatContext();
  const slugs = section.slugs ?? [];
  // A slug is renderable only when the authoritative provider payload has
  // supplied its title and URL. Never expose an unresolved generated slug.
  const pages = slugs
    .map((slug) => payload.pages.find((page) => page.slug === slug))
    .filter((page): page is NonNullable<typeof page> => Boolean(page?.url));

  if (pages.length === 0) return null;

  return (
    <section className="tw-mt-2">
      <h3 className="tw-font-serif tw-text-[15.5px] tw-font-bold tw-text-cal-ink tw-mb-2">
        {getLabel('related_pages_title', locale)}
      </h3>
      <ul className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-text-[14px] tw-leading-relaxed tw-list-none tw-p-0 tw-m-0">
        {pages.map((page) => {
          return (
            <li key={page.slug}>
              <a
                href={page.url}
                content-content="chatbot-pages"
                target="_blank"
                rel="noopener noreferrer"
                className="gtmtrack tw-text-cal-green-700 tw-font-semibold tw-underline tw-decoration-cal-green-200 tw-decoration-2 tw-underline-offset-2 hover:tw-decoration-cal-green-500 hover:tw-text-cal-green-900 tw-transition-colors"
              >
                {page.title} ↗
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
